<div class="listview__container_core" dropdown (onShown)="onShown()" (onHidden)="onHidden()">
  <a dropdownToggle class="top-nav__notify" (click)="openNotification()">
    <img src="assets/images/notification-32.svg" style="width: 38px">
    <div *ngIf="unReadNotifications" class="badge" style="position: absolute;bottom: -0.5rem; left: 2rem;" class="badge-circle"></div>
  </a>

  <div *dropdownMenu class="dropdown-menu dropdown-menu-right dropdown-menu--block" role="menu">
    <div class="listview listview--hover" *ngIf="loading">
      <div class="loader loader-sm loader-search"></div>
    </div>

    <div class="listview listview--hover" *ngIf="!loading">
      <div class="listview__content-items_core">
        <perfect-scrollbar class="perfect-scrollbar_core">
          <ng-container *ngFor="let notifications of notificationsData">
            <span class="date_item"> {{ notifications?.key | translate}} </span>

            <div *ngFor="let notification of notifications?.value" [class.cursor-pointer]="notification?.url"
              class="listview__item" [class.readed]="notification?.read" (click)="navigate(notification)">

              <div class="notification-line">
                <h3 class="listview__heading m-0">
                  {{ notification.processNumber }}
                  <small class="ball-blue float-left pr-3">
                    <i class="zmdi zmdi-circle zmdi-hc-lg vertical-ball"></i>
                    <span class="text-muted notification-hour">{{ notification.screenDate | hourMinute }}</span>
                  </small>
                </h3>
                <span class="notification-content"> {{ notification.applicationContent }} </span>
                <span class="text-muted notification-port"> {{ notification?.port?.code }} - {{
                  notification?.port?.description }} </span>
              </div>

            </div>

          </ng-container>
          <div class="card shadow-none" *ngIf="error">
            <div>
              <div class="text-center">
                <i class="zmdi zmdi-alert-circle-o zmdi-hc-4x text-muted mb-3"></i>
                <div class="h5 text-muted">Não foi possível obter as notificações</div>
              </div>
            </div>
          </div>
          <div class="card shadow-none border-0" *ngIf="notificationsData?.length===0 && !error && !loading">
            <div class="mt-4">
              <div class="text-center">
                <div class="h5 text-muted">Não existem novas notificações</div>
              </div>
            </div>
          </div>

        </perfect-scrollbar>
      </div>

      <span class="see-all" (click)="openNotificationsPage()" *ngIf="!error"> {{ 'generic.see.all' | translate }}
        <img src="assets/images/navigation-arrow-right-35.svg">
      </span>
    </div>
  </div>

</div>
